
import { Injectable } from '@angular/core';
import { ViewChild } from '@angular/core';
import { Observable } from 'rxjs';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor,
  HttpResponse,
  HttpErrorResponse

} from '@angular/common/http';
import 'rxjs/add/operator/do';
import { AESService } from '../encryption/aes.service';
import { Router } from '@angular/router';
import Swal from 'sweetalert2';
import { NgxSpinnerService } from 'ngx-spinner';


/*
  Generated class for the InterceptorProvider provider.

  See https://angular.io/guide/dependency-injection for more info on providers
  and Angular DI.
*/
@Injectable()

export class InterceptorService implements HttpInterceptor {
  
  variable: boolean;
  constructor(public Cryptography : AESService,private route : Router,private ngxService:NgxSpinnerService) {


  }
  showmissing() {
    Swal.fire({
      title: 'Session Expired!',
      text: 'Please Login Again to Continue',
      icon: 'warning',
     
    })
  }
  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {

    if (!this.Cryptography.getItem('accesstoken',true)) {
      request = request.clone({
        setHeaders: {
          'Access-Control-Allow-Origin': '*',
          'Content-Type': `application/json`,
          // 'Content-Type': 'multipart/form-data',
          'Cache-Control':  'no-cache, no-store, must-revalidate, post- check=0, pre-check=0',
          'Pragma': 'no-cache'
        }
      });
    } else {
      // if (request.body instanceof FormData) {
      //   request = request.clone({
      //     setHeaders: {
      //       'Access-Control-Allow-Origin': '*',
      //       // 'Content-Type': `application/json`,
      //       'Content-Type': 'multipart/form-data',
      //       'Cache-Control':  'no-cache, no-store, must-revalidate, post- check=0, pre-check=0',
      //       'Pragma':'no-cache',
      //
      //       Authorization: `Bearer ${this.Cryptography.getItem('accesstoken',true)}`
      //     }
      //   });
      // } else {
      //   request = request.clone({
      //     setHeaders: {
      //       'Access-Control-Allow-Origin': '*',
      //       'Content-Type': `application/json`,
      //       // 'Content-Type': 'multipart/form-data',
      //       'Cache-Control':  'no-cache, no-store, must-revalidate, post- check=0, pre-check=0',
      //       'Pragma':'no-cache',
      //
      //       Authorization: `Bearer ${this.Cryptography.getItem('accesstoken',true)}`
      //     }
      //   });
      // }
      request = request.clone({
        setHeaders: {
          'Access-Control-Allow-Origin': '*',
          // 'Content-Type': `application/json`,
          // 'Content-Type': 'multipart/form-data',
          'Cache-Control':  'no-cache, no-store, must-revalidate, post- check=0, pre-check=0',
          'Pragma': 'no-cache'
        }
      });
    }
    return next.handle(request).do((event: HttpEvent<any>) => {
      if (event instanceof HttpResponse) {
        this.Cryptography.setItem('viewindex', '0',true);
      }
    }, (err: any) => {

      if (err instanceof HttpErrorResponse) {
        if ((err.status === 401 || err.status === 500 || err.status === 403)&& this.Cryptography.getItem('viewindex',true)) {
        this.ngxService.hide()
          this.showmissing();
          localStorage.clear();
          // let ve = this.authservice.isLoggedIn = false;
          // alert('login again to continue')
         this.route.navigate(['/login']);
        }
      }
    });
  }
}
